import React from "react";
import { FieldContextProps } from ".";

export const fieldRendererContext = React.createContext<FieldContextProps | null>(null);

export const useFieldContext = () => {
    const context = React.useContext(fieldRendererContext);
    if (!context) {
        throw new Error("useFieldContext must be used within FieldGeneratorProvider");
    }
    return context;
};